

export const getRegionCode = (languageCode) => {
  switch (languageCode) {
    case 'EN-CA':
    case 'FR-CA':
      return regions.CAN;
    case 'EN-US':
    default:
      return regions.USA;
  }
};

export const regions = {
  CAN: 'CA',
  USA: 'US'
};
